import { CanMatchFn } from '@angular/router';

import { environment } from '@finverity/platform-app/env/environment';

/**
 * Blocks direct URL access to the NPL approvals queue on deployments whose gateway does not serve
 * the NPL surface. When it denies the match, the router falls through to the wildcard route which
 * redirects to the dashboard, so the queue cannot be reached by link while the menu item is hidden.
 */
export const CanMatchNplApprovalsRoute: CanMatchFn = () => Boolean(environment.platform.isNplStatusEnabled);
